import { Box, Skeleton } from "@mui/material";

const SkeletonForm = () => {
  return (
    <>
      <Box p="16px" className="w-full max-w-[392px]">
        <Skeleton variant="text" className="text-xl w-[50%]" />
        <Skeleton variant="text" className="text-sm" />
        <div className="flex flex-col self-stretch gap-3 mb-4">
          <Skeleton variant="text" className="w-[30%]" />
          <Skeleton variant="rounded" className="h-14" />
          <Skeleton variant="text" className="w-[30%]" />
          <Skeleton variant="rounded" className="h-14" />
        </div>
        <div className="flex md:justify-end">
          <Skeleton variant="rounded" className="w-[120px] h-9" />
        </div>
      </Box>
    </>
  );
};

export default SkeletonForm;
